import { useState, useEffect } from 'react';

/**
 * @param {Object[]} _breakpoints - 해상도 구간과 값 정의
 *   [{ min: number, max?: number, value: any }]
 */

export default function useResponsiveValue(_breakpoints) {
  const [param, setParam] = useState('');

  useEffect(() => {
    const updateValue = () => {
      const screenWidth = window.innerWidth;
      let matched = '';

      for (let bp of _breakpoints) {
        const { min, max, value } = bp;
        if (min <= screenWidth && (max === undefined || screenWidth < max)) {
          matched = value;
          break;
        }
      }

      setParam(matched);
    };

    updateValue(); // 초기 실행
    window.addEventListener('resize', updateValue);
    return () => window.removeEventListener('resize', updateValue);
  }, [_breakpoints]);

  return param;
}
